<template>
  <span class="badge gray ml-2"><slot>Archived</slot></span>
</template>
